import { createSlice } from '@reduxjs/toolkit';
import { reHydrateStore } from '../utils/local-storage';

const initialState = {
  custom: null,
  booking: null,
  tickets: null,
  merch: null,
};

const slice = createSlice({
  name: 'surveys',
  initialState: reHydrateStore('surveys') || initialState,
  reducers: {
    setSurveys: (state, { payload }) => ({ ...payload }),
    setCustomSurvey: (state, { payload }) => ({
      ...state,
      custom: payload,
    }),
    setBookingSurvey: (state, { payload }) => ({
      ...state,
      booking: payload,
    }),
    setMerchSurvey: (state, { payload }) => ({
      ...state,
      merch: payload,
    }),
    setTicketsSurvey: (state, { payload }) => ({
      ...state,
      tickets: payload,
    }),
    restore: () => initialState,
  },
});

export const {
  setSurveys,
  setCustomSurvey,
  setBookingSurvey,
  setTicketsSurvey,
  setMerchSurvey,
  restore,
} = slice.actions;

export default slice.reducer;
